import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { ApiTypes } from 'common';
import { ApiError } from '@src/services/api';
import { getAllProductGroups, getProductGroups } from './api';
import { ProductGroup } from 'common/dist/types/apiTypes';

export const useQueryProductGroups = (
  params: Parameters<typeof QUERY_KEYS.productGroupsParams>[0],
  config?: { enabled?: boolean }
) =>
  useInfiniteQuery({
    queryKey: QUERY_KEYS.productGroupsParams(params),
    queryFn: async ({ pageParam: cursor }) =>
      getProductGroups({
        cursor: cursor as string | undefined,
        ...params,
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastRes) => lastRes.cursor,
    ...config,
  });

export const useQueryAllProductGroups = () =>
  useQuery({
    queryKey: [QUERY_KEYS.productGroups()],
    queryFn: async (): Promise<ProductGroup[]> => {
      const res = await getAllProductGroups();
      return res.productGroups;
    },
  });
